import * as React from 'react';
import { routes } from '../../../../client/__config__/routes';
import { useDigger } from '../hooks/useDigger';

export type SiteTheme = 'nybygg_old_black' | 'nybygg_old_white';

interface ISiteContext {
  digger: any;
  galleryOpen: boolean;
  setGalleryOpen: (value: boolean) => void;
  showBookingForm: boolean;
  setShowBookingForm: (value: boolean) => void;
  routeConfig: any;
  googleMapsInitialized: boolean;
  googleMapInstance: any;
  setGoogleMapInstance: (value: any) => void;
  setGoogleMapInitialized: (value: boolean) => void;
}

export const SiteContext = React.createContext<ISiteContext>({
  digger: null,
  galleryOpen: false,
  setGalleryOpen: () => {},
  showBookingForm: false,
  setShowBookingForm: () => {},
  routeConfig: {},
  googleMapsInitialized: false,
  googleMapInstance: null,
  setGoogleMapInstance: () => {},
  setGoogleMapInitialized: () => {},
});

export const SiteContextProvider: React.FC = ({ children }) => {
  const { digger } = useDigger();
  const [galleryOpen, setGalleryOpen] = React.useState<boolean>(false);
  const [showBookingForm, setShowBookingForm] = React.useState<boolean>(false);
  const [googleMapInstance, setGoogleMapInstance] = React.useState<any>(null);
  const [googleMapsInitialized, setGoogleMapInitialized] =
    React.useState<boolean>(false);

  return (
    <SiteContext.Provider
      value={{
        digger,
        galleryOpen,
        setGalleryOpen,
        showBookingForm,
        setShowBookingForm,
        routeConfig: routes,
        googleMapsInitialized,
        googleMapInstance,
        setGoogleMapInitialized,
        setGoogleMapInstance,
      }}
    >
      {children}
    </SiteContext.Provider>
  );
};
